/* 工具函数 */
export const regIdNumber=/(^\d{18}$)|(^\d{17}(\d|X|x)$)/;//身份证号
export const regIphone=/^1[0-9]\d{9}$/; //手机号
export const regPsd=/(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\W_])/; //密码
export const regEmail=/^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/; //邮箱
